import { render, staticRenderFns } from "./EditSimple.vue?vue&type=template&id=1961ad15&scoped=true"
import script from "./EditSimple.vue?vue&type=script&lang=js"
export * from "./EditSimple.vue?vue&type=script&lang=js"
import style0 from "./EditSimple.vue?vue&type=style&index=0&id=1961ad15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1961ad15",
  null
  
)

export default component.exports